import { render, staticRenderFns } from "./InvoiceDetailsModal.vue?vue&type=template&id=27fca19c&scoped=true&"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetailsModal.vue?vue&type=style&index=0&id=27fca19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fca19c",
  null
  
)

export default component.exports